import React from "react";
import Body from "../components/v2/Body";
import glacier from '../imgs/glacier.jpeg';
import madden from '../imgs/madden23.jpeg';
import concord from '../imgs/concord169.png'

import "./Home.css"

const Home = () => {
    const mainContent = {
        'title': "Hello, I'm Jerry!",
        'description': "Engineering for 6 years, AAA games for 3.  I can happily say that I'm living the dream!",
        'img': glacier
    }

    const projects = [
        {
            'title': 'Concord',
            'link': 'https://www.playstation.com/en-us/games/concord/',
            'description': 'A PVP multiplayer FPS set in an original sci-fi universe - Released on PS5 and PC - Made using Unreal Engine 5.  ' 
                    + 'My primary focus was the Galactic Guide, a game mode that helps you learn more about the Concord universe.  '
                    + 'I can proudly say that whatever you see in the Galactic Guide, I have touched it in some way - Systems, Gameplay, UI or anything in between.  '
                    + 'I also work alongside the Gameplay team to fix issues and update character abilities while always keeping networking in mind.  ',
            'img': concord
        },
        {
            'title': 'Madden NFL 23',
            'link': 'https://www.ea.com/games/madden-nfl/madden-nfl-23',
            'description': 'Released on PS4, PS5, Xbox Series X/S, Xbox One, PC.  Made using the Frostbite engine.  '
                    + 'My team worked on various aspects of the game including the modes The Yard, Franchise, and Ultimate Team.',
            'img': madden
        },
        {
            'title': 'Unannounced Project',
            'description': 'Planned release on PS5, Xbox Series X/S, and PC using a proprietary engine.  '
                    + 'My team focused on porting the game to consoles and performance enhancements.'
        },
    ]
    return (
        <div className="home">
            <Body main={mainContent} details={projects}/>
        </div>
    );
};
 
export default Home;